import { createLink } from '@tanstack/react-router'
import type { ComponentProps, ReactNode } from 'react'
import { NavAnchor, type NavAnchorProps } from '../NavLink/NavLink'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

export type IconAnchorProps = Omit<NavAnchorProps, 'aria-label' | 'children'> & {
  label: string
  side?: ComponentProps<typeof TooltipContent>['side']
  children: ReactNode
}

function IconAnchor({
  label,
  side = 'bottom',
  size = 'icon-sm',
  children,
  ...anchor
}: IconAnchorProps) {
  return (
    <Tooltip>
      <TooltipTrigger render={<NavAnchor {...anchor} size={size} aria-label={label} />}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  )
}

export const IconLink = createLink(IconAnchor)
